import { render, staticRenderFns } from "./FriendSharingDetailsDialog.vue?vue&type=template&id=910549dc&scoped=true&"
import script from "./FriendSharingDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./FriendSharingDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./FriendSharingDetailsDialog.vue?vue&type=style&index=0&id=910549dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910549dc",
  null
  
)

export default component.exports